import { FetchApi } from '../ApiFetch/ApiFetch';
import { ServiceType } from '../ApiFetch/ServiceType.types';
import { HTTPMethod } from '../ApiFetch/HTTPMethod.types';
import { CreateTextResponse, ResponseData } from '../ApiFetch/ApiResponse';
import { ApiUrls } from '../ApiConstants/ApiUrls';

export const importStatistics = async (startDate: Date, endDate: Date): Promise<ResponseData> => {
    try
    {
        const url = ApiUrls.GET_IMPORT_STATISTICS
            .replace('{startDate}', formatDateToString(startDate))
            .replace('{endDate}', formatDateToString(endDate));
        const response = await FetchApi({
            endpoint: url,
            apiType: ServiceType.Import,
            method: HTTPMethod.Get,
        });
        return CreateTextResponse(response);
    } catch (e)
    {
        throw e;
    }
};

export const calculationStatistics = async (startDate: Date, endDate: Date): Promise<ResponseData> => {
    try
    {
        const url = ApiUrls.GET_CALCULATION_STATISTICS
            .replace('{startDate}', formatDateToString(startDate))
            .replace('{endDate}', formatDateToString(endDate));
        const response = await FetchApi({
            endpoint: url,
            apiType: ServiceType.Calculation,
            method: HTTPMethod.Get,
        });
        return CreateTextResponse(response);
    } catch (e)
    {
        throw e;
    }
};

const formatDateToString = (date: Date): string => {
    return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
}